import { mapGetters } from 'vuex';
import mvtCollapsibleLinks from '@/common/components/mvtcollapsiblelinks/mvt-collapsiblelinks.vue';
import staticWelcomeSearch from '../staticwelcomesearch/static-welcome-search.vue';
import mvtPageMenu from '@/common/components/mvtpagemenu/mvt-pagemenu.vue';
import schoolsBreadcrumb from "@/schools/components/schoolsbreadcrumb/schools-breadcrumb.vue";

export default {
    name: 'schoolsBase',
    inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            default: {}
        }
    },
    components: {
     staticWelcomeSearch,
     mvtPageMenu,
     mvtCollapsibleLinks,
        schoolsBreadcrumb,
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        getBreadCrumbData() {
          return this.data.breadCrumb;
        }
    },
    methods: {
        formatDataList(list) {
            return list && list.map(item => {
                return {
                        url: `${this.glb.appUrl}${item.nameForUrl}`,
                        text: item.displayName
                }
            });
        },
    },
};